<template>
  <div id="Pay">
    <!-- 弹框群组 -->
    <!-- 微信支付弹窗 -->
    <vueModal v-model:data_isShow="payQRCode_b" :data_closeBtn="true">
      <div class="wxBox">
        <div v-if="!iframeSrc" id="qrcodeCanvas_pay"></div>
        <iframe v-else :src="iframeSrc" width="184" height="184"></iframe>
        <div>
        <span>
          请使用{{payForType_fn(data_toPayFor_n,shenbei_toPayFor_n)}}扫一扫
          <br/>
          扫描二维码支付
        </span>
          <i>请在10分钟内完成支付</i>
        </div>
      </div>
      <p class="prompt_message">完成支付前，请勿离开此页面</p>
    </vueModal>

    <!-- 购买成功 -->
    <vueModal v-model:data_isShow="paySuccess_b" :data_closeBtn="false">
      <div class="finishPay">
        <CheckCircleFilled/>
        <i>购买成功</i>
        <div @click="toCourse_fn">查看我的课程</div>
      </div>
    </vueModal>

    <!-- 神贝充值 -->
    <vueModal v-model:data_isShow="exchange_b" :data_title="'神贝充值'">
      <div class="recharge">
        <div class="item">
          <div class="msg">
            <h3>选择充值金额：</h3>
            <span>余额：<i>{{shenbeiBalance}}神贝</i></span>
          </div>
          <ul class="payNum">
            <li v-for="(item,index) in recharge_a" :key="index" :class="{'active':recharge_active.id === item.id}" @click="recharge_fn(item)">
              <CheckOutlined/>
              <b>{{item.shenbei}}神贝</b>
              <i>￥{{item.price}}</i>
            </li>
          </ul>
        </div>
        <div class="item">
          <div class="msg">
            <h3>选择付款方式：</h3>
          </div>
          <ul class="payType">
            <li v-for="(item,index) in modeOfPment_a" @click="modeOfPment_aType_fn(index)" :key="index"
                :class="{'active':(shenbei_toPayFor_n === index)}">
              <CheckOutlined/>
              <img :src="item.img" alt="">
              {{item.name}}
            </li>
          </ul>
        </div>
        <div class="pay" v-if="recharge_active">
          <span>充值金额：<i>¥ {{recharge_active.price}}</i></span>
          <b @click="shenbeiorder_fn">立即支付</b>
        </div>
      </div>
    </vueModal>
    <div class="shenbeiAliPay" v-html="shengbeiAliPayIframe.text"></div>
  </div>
</template>

<script>
  import {CheckCircleFilled, CheckOutlined} from '@ant-design/icons-vue';
  import vueModal from '@c/Modal.vue';
  import {
    wxOrderQuery,
    aliOrderQuery,
    getShenbeiRateList,
    shenbeiorder,
    shenbeipay,
    cancelOrder
  } from "@/api";
  import QRCode from "qrcodejs2";
  import {message, Modal} from "ant-design-vue";

  export default {
    name: "Pay",
    components: {
      CheckCircleFilled,
      CheckOutlined,
      vueModal,
      [Modal.name]: Modal,
    },
    // 1.wx，alipay 显示二维码   data_toPayFor_n：课程支付方式
    props: ['data_isShow', 'data_toPayFor_n','aliPayIframe','userId','shenbeiBalance'],
    computed:{
      payForType_fn(){
        return (data_toPayFor_n,shenbei_toPayFor_n)=>{
          if(data_toPayFor_n === 0){
            return '微信';
          }else if(data_toPayFor_n === 1){
            return '支付宝';
          }else if(data_toPayFor_n === 2){
            if(shenbei_toPayFor_n === 0){
              return '微信';
            }else if(shenbei_toPayFor_n === 1){
              return '支付宝';
            }
          }
        }
      },
    },
    data() {
      return {
        recharge_a:[], // 神贝充值费率表
        recharge_active: {}, // 神贝充值费率表 选中
        // 付款方式
        // 费率 支付类型
        modeOfPment_a: [
          {name: '微信支付', img: require("@a/img/icon_weixin.png")},
          {name: '支付宝', img: require("@a/img/icon_zhifubao.png")}
        ],
        shenbei_toPayFor_n: 0,          // 神贝支付方式 0微信 1支付宝
        shenbei_recharge_s: '',         // 神贝充值订单号

        // 支付宝 微信
        payQRCode_b: false,   // 是否显示支付二维码
        paySuccess_b: false,  // 是否支付成功
        // 神贝
        exchange_b: false,      // 选择充值金额 是否显示

        pay_succeed_interval: null, // 查询支付是否成功 轮循

        shengbeiAliPayIframe: {}, // 神贝ali支付二维码

        iframeSrc:'', // iframe 实际要加载的页面
      }
    },
    methods: {
      // 生成微信二维码
      setQRcode(url) {
        if(url){
          this.link = url;
          if (!document.querySelector('#qrcodeCanvas_pay')) {
            return;
          }
          document.querySelector('#qrcodeCanvas_pay').innerHTML = '';
          // 因为可能获取不到页面dom所以延迟
          new QRCode("qrcodeCanvas_pay", {
            width: 98,
            height: 98, // 高度
            text: this.link, // 二维码内容
            // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            // background: '#f0f',   // 背景色
            // foreground: '#ff0'    // 前景色
          });
        }
      },

      isPaySucceed(url,payOrder,type){
        this.setQRcode(url);
        if(type === 'kecheng'){
          // 课程支付
          this.pay_succeed_interval = setInterval(() => {
            if (this.$props.data_toPayFor_n === 0) {
              // 微信查询支付
              wxOrderQuery({
                orderNumber: payOrder,
              }).then(res => {
                console.log('微信支付是否成功', res);
                if(res.data.code === 1){
                  if(res.data.data.trade_state === "SUCCESS"){
                    clearInterval(this.pay_succeed_interval);
                    this.paySuccess_b = true;
                  }
                }else{
                  let that = this;
                  Modal.confirm({
                    title: '提示',
                    content: res.msg,
                    centered: true,
                    okText: '确定',
                    onOk() {
                      that.$router.push('/pages/coursePlay/coursePlay?courseId=' + that.$route.query.courseId)
                    },
                  });
                }
              })
            } else if (this.$props.data_toPayFor_n === 1) {
              // 支付宝查询支付
              aliOrderQuery({
                orderNumber: payOrder,
              }).then(res => {
                console.log('支付宝支付是否成功', res);
                if(res.data.code === 1){
                  if(res.data.data.trade_status === "TRADE_SUCCESS"){
                    clearInterval(this.pay_succeed_interval);
                    this.paySuccess_b = true;
                  }
                }else{
                  let that = this;
                  Modal.confirm({
                    title: '提示',
                    content: res.msg,
                    centered: true,
                    okText: '确定',
                    onOk() {
                      that.$router.push('/pages/coursePlay/coursePlay?courseId=' + that.$route.query.courseId)
                    },
                  });
                }
              })
            }
          }, 1000)
        }else if(type === 'shengbei'){
          // 神贝充值
          this.pay_succeed_interval = setInterval(() => {
            if (this.shenbei_toPayFor_n === 0) {
              // 微信查询支付
              wxOrderQuery({
                orderNumber: payOrder,
              }).then(res => {
                console.log('微信支付是否成功', res);
                if(res.data.code === 1){
                  if(res.data.data.trade_state === "SUCCESS"){
                    clearInterval(this.pay_succeed_interval);
                    this.payQRCode_b = false; // 关闭弹窗
                    message.info('充值成功！');
                    setTimeout(()=>{
                      this.$emit('getUserWallet_fn'); // 更新神贝余额
                    },3000)
                  }
                }
              })
            } else if (this.shenbei_toPayFor_n === 1) {
              // 支付宝查询支付
              aliOrderQuery({
                orderNumber: payOrder,
              }).then(res => {
                console.log('支付宝支付是否成功', res);
                if(res.data.data.trade_status === "TRADE_SUCCESS"){
                  clearInterval(this.pay_succeed_interval);
                  this.payQRCode_b = false; // 关闭弹窗
                  message.info('充值成功！');
                  setTimeout(()=>{
                    this.$emit('getUserWallet_fn'); // 更新神贝余额
                  },3000)
                }
              })
            }
          }, 1000)
        }
      },

      // 关闭弹窗
      onDeobligation_fn() {
        this.iframeSrc = '';
        clearInterval(this.pay_succeed_interval);
      },
      // payStep-2 微信、支付宝 完成支付弹窗

      // 神贝充值费率列表
      getRecharge_fn(){
        getShenbeiRateList({
          rechargeChannel: 'O',
        }).then(res=>{
          console.log('费率',res);
          if(res.data.code === 1){
            this.recharge_a = res.data.list;
            this.recharge_active = res.data.list[0];
          }
        })
      },
      // 点击费率
      recharge_fn(item){
        this.recharge_active = item;
      },

      // 神贝充值 生成产品订单
      shenbeiorder_fn(){
        shenbeiorder({
          userId: this.userId,
          shenbeiRateId: this.recharge_active.id
        }).then(res=>{
          console.log('神贝充值',res)
          if(res.code === 1){
            // 神贝充值订单号
            this.shenbei_recharge_s = res.data.orderNumber;
            this.shenbeipay_fn();
          }
        })
      },

      // 生成支付订单
      shenbeipay_fn(){
        shenbeipay({
          orderNumber: this.shenbei_recharge_s,
          productId: this.recharge_active.id,
          paymentMethod: (this.shenbei_toPayFor_n === 0 ? 'weixin-payment' : 'alipay-payment')
        }).then(res=>{
          console.log('支付订单',res)
          if(res.code === 1){
            this.shengbeiAliPayIframe = {};
            document.querySelector('.shenbeiAliPay').innerHTML = '';

            if(res.data.status === 'F'){
              cancelOrder({
                userId: this.userId,
                orderNumber: this.orderNumber,
              }).then(res=>{
                console.log('关闭订单',res)
                if(res.code === 1){
                  this.payFor_fn();
                }
              })
              return;
            }
            if(this.shenbei_toPayFor_n === 0){
              // 微信支付
              this.payQRCode_b = true;
              this.exchange_b = false;
              this.isPaySucceed(res.data.code_url,res.data.orderNumber,'shengbei');
            }else if(this.shenbei_toPayFor_n === 1){
              this.shengbeiAliPayIframe.text = res.data.orderInfoString
              // 支付宝支付
              this.shengbeiAliPayIframe.origin = /action\=\"([\w|\W]+json)/.exec(res.data.orderInfoString)[1]
              this.$nextTick(()=>{
                let dataVal = document.querySelector('.shenbeiAliPay input[name="biz_content"]').value;
                this.shengbeiAliPayIframe.src = this.shengbeiAliPayIframe.origin + '&biz_content=' + dataVal;
                this.iframeSrc = '';
                this.iframeSrc = this.shengbeiAliPayIframe.src;
              })

              // 显示弹窗
              this.payQRCode_b = true;
              this.exchange_b = false;
              this.isPaySucceed('',this.shenbei_recharge_s,'shengbei');
            }
          }
        })
      },

      // 跳转播放页
      toCourse_fn() {
        this.$router.push('/pages/coursePlay/coursePlay?courseId=' + this.$route.query.courseId)
      },
      // 支付类型
      modeOfPment_aType_fn(type) {
        this.shenbei_toPayFor_n = type;
      },
    },
    mounted() {
      // 神贝充值费率列表
      this.getRecharge_fn();
    },
    watch: {
      aliPayIframe:{
        handler(newV, oldV) {
          this.iframeSrc = '';
          this.iframeSrc = newV.src;
        },
        deep: true,
      },

      // 捕获显示弹窗 data_isShow
      data_isShow: {
        handler(newV, oldV) {
          this.exchange_b = newV.isRecharge;      // 充值
          this.payQRCode_b = newV.isPayQRCode_b;  // 支付
        },
        deep: true,
      },
      // 支付
      payQRCode_b(n) {
        if(!n){
          this.onDeobligation_fn();
        }
        // 如果弹出框点击X，那么要将modal传回来的状态传出去
        let showModal = {
          isPayQRCode_b: n,    // 支付弹窗
          isRecharge: this.exchange_b,      // 充值
        }
        this.$emit('update:data_isShow', showModal)
      },
      // 充值
      exchange_b(n) {
        let showModal = {
          isPayQRCode_b: this.payQRCode_b,    // 支付弹窗
          isRecharge: n,      // 充值
        }
        this.$emit('update:data_isShow', showModal)
      },
    },
    beforeUnmount() {
      clearInterval(this.pay_succeed_interval);
    }
  }
</script>

<style scoped lang="scss">
  /*付款扫码*/
  .wxBox {
    padding: 12px 62px 0;
    display: flex;

    #qrcodeCanvas_pay,iframe {
      /*width: 184px;*/
      /*height: 184px;*/
      margin-right: 30px;
      width: 188px;
      height: 192px;
      border: none;
    }
    #qrcodeCanvas_pay{
      :deep(img),:deep(canvas){
        height: 100%;
      }
    }

    div {
      display: flex;
      flex-direction: column;

      span {
        font-size: 18px;
        color: #333;
      }

      i {
        margin-top: 18px;
        color: #7AA5C0;
      }

      b {
        font-size: 14px;
        line-height: 44px;
        width: 170px;
        text-align: center;
        color: #fff;
        background: $theme_blue;
        margin-top: auto;
        border-radius: 6px;
        cursor: pointer;
      }
    }
  }

  .prompt_message{
    padding: 12px 62px 40px;
    text-align: center;
    color: red;
    font-size: 16px;
  }

  /*付款成功*/
  .finishPay {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 510px;
    padding: 38px 0 88px;

    .anticon {
      font-size: 60px;
      color: $theme_blue;
    }

    i {
      margin: 20px 0 60px;
      font-size: 22px;
    }

    div {
      font-size: 14px;
      line-height: 44px;
      width: 170px;
      text-align: center;
      color: #fff;
      background: $theme_blue;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  /* 去使用兑换码 */
  .exchangeCode {
    padding: 0 0 52px;
    width: 470px;
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      display: inline-block;
      font-size: 20px;
      margin: 17px 0 20px;
    }

    div {
      font-size: 14px;
      line-height: 44px;
      width: 126px;
      text-align: center;
      color: #fff;
      background: #0581CE;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  /* 充值页面 */
  .recharge {
    width: 700px;
    padding: 0 60px 50px;

    .item {
      .msg {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        margin: 30px 0 0;

        h3 {
          font-size: 16px;
        }

        span {
          i {
            color: $theme_blue;
          }
        }
      }

      .payNum {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 4px;

        li {
          width: 180px;
          padding: 9px;
          border-radius: 6px;
          border: 1px solid #A8A8A8;
          flex: 0 0 auto;
          margin-top: 15px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;
          cursor: pointer;

          /* 选中样式 */
          span {
            position: absolute;
            z-index: 1;
            top: 3px;
            right: 3px;
            color: #fff;
            font-size: 12px;
            display: none;
          }

          b {
            font-size: 16px;
            color: $theme_blue;
          }

          i {
            margin-top: 4px;
            font-size: 14px;
          }

          &.active {
            border-color: $theme_blue;

            &::after {
              content: '';
              width: 46px;
              height: 46px;
              border-radius: 50%;
              background: $theme_blue;
              position: absolute;
              top: -46px;
              right: -46px;
              transform: translate(-50%, 50%);
            }

            span {
              display: block;
            }
          }
        }
      }

      .payType {
        display: flex;
        margin-top: 15px;

        li {
          width: 169px;
          height: 55px;
          line-height: 55px;
          text-align: center;
          border-radius: 6px;
          border: 1px solid #A8A8A8;
          margin-right: 20px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          user-select: none;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          cursor: pointer;

          /* 选中样式 */
          span {
            position: absolute;
            z-index: 1;
            top: 3px;
            right: 3px;
            color: #fff;
            font-size: 12px;
            display: none;
          }

          img {
            width: 24px;
            margin-right: 0.7rem;
          }

          &.active {
            border-color: $theme_blue;

            &::after {
              content: '';
              width: 46px;
              height: 46px;
              border-radius: 50%;
              background: $theme_blue;
              position: absolute;
              top: -46px;
              right: -46px;
              transform: translate(-50%, 50%);
            }

            span {
              display: block;
            }
          }
        }

        & li:nth-of-type(3) img {
          border-radius: 50%;
        }
      }
    }

    /* 金额和支付 */
    .pay {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 40px;
      cursor: pointer;

      span {
        color: #666666;
        font-size: 16px;
        display: flex;
        align-items: center;

        i {
          font-size: 22px;
          color: #F76B03;
        }
      }

      b {
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 44px;
        width: 126px;
        border-radius: 6px;
        background: $theme_blue;
      }
    }
  }
</style>
